import { DateTimePicker } from "Components/Generic/DateTimePicker";
import { isDateTimeField } from "Utils/Metadata";
import { IEditFieldProps } from "../IEditFieldProps";
import { useEditDate } from "./Hooks/UseEditDate";

export function EditDateTime(props: IEditFieldProps): JSX.Element {
  const { htmlId, disabled } = props;
  const { errorMessage, value, onChange } = useEditDate(props);

  return (
    <DateTimePicker
      datePickerProps={{ id: htmlId }}
      disabled={disabled}
      errorMessage={errorMessage}
      isDateTime={isDateTimeField(props)}
      onChange={onChange}
      value={value}
    />
  );
}
